import React from "react";
import styled from "styled-components";

// TitleBlock は .jsx のため TS の型宣言ファイルが無いので個別に抑制する。
// @ts-ignore
import TitleBlock from "../../../components/block/TitleBlock";

/**
 * いずれも親（ProjectCreation）側で `trim()` 済みの値を受け取る前提。
 * 確認画面では純粋に表示にのみ責任を持ち、未設定判定は空文字一致で行う。
 */
interface ProjectCreationConfirmProps {
  codeName: string;
  finalWork: string;
  endClient: string;
}

const SummaryList = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--soremo-border);
  border-radius: 8px;
  background-color: #fff;
`;

const SummaryItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;

  & + & {
    border-top: 1px solid var(--soremo-border);
  }
`;

const ItemValue = styled.div`
  word-break: break-all;
  white-space: pre-wrap;
`;

/**
 * プロジェクト作成ウィザードの確認ステップ。ここまで入力した内容を一覧で
 * 見せ、「作成する」ボタンで実際に POST する。値の編集は前のステップへ
 * 戻って行う（Stepper のクリック遷移で任意ステップへ戻れる）。
 */
const ProjectCreationConfirm: React.FC<ProjectCreationConfirmProps> = ({
  codeName,
  finalWork,
  endClient,
}) => {
  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="入力内容の確認"
        description="入力内容を確認して「作成する」をクリックしてください。修正したい項目があれば、上のステップをクリックして戻ることができます。"
      />
      <SummaryList>
        <SummaryItem>
          <span className="bodytext-11 u-text-light-gray">コードネーム</span>
          <ItemValue className="heading-spacing-18">{codeName}</ItemValue>
        </SummaryItem>
        <SummaryItem>
          <span className="bodytext-11 u-text-light-gray">目的物</span>
          <ItemValue className="bodytext">{finalWork}</ItemValue>
        </SummaryItem>
        <SummaryItem>
          <span className="bodytext-11 u-text-light-gray">エンドクライアント</span>
          <ItemValue className="bodytext">
            {endClient === "" ? (
              <span className="u-text-light-gray">（未設定）</span>
            ) : (
              endClient
            )}
          </ItemValue>
        </SummaryItem>
      </SummaryList>
    </div>
  );
};

export default ProjectCreationConfirm;
